import {
  Icon,
  Button,
  Dialog,
  FormGroup,
  Input,
  Select,
  Uploader,
  Checkbox,
} from '@tencent/spaui';
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { RPCFactory } from '../../../../utils/RequestUtil';
import WechatEditDialog from './WechatEditDialog';

const welcomeDetailInfoInit = {
  welcomeMsgName: '',          //欢迎语消息名称
  msgContent: '',       //消息文本内容
  wxWorkUserIdRange: 1,      //客服范围：0 全部客服  1 具体的客服人员
  wxWorkUserIdList: [],     //客服范围 wxWorkUserIdRange=1时有效  
  // createdTime: '',    //消息创建时间
  // creatorWxWorkUserId: '',    //创建人
  attachments:[
    // {
    //   "cosKey": "",
    //   "miniprogramTitle": "",
    //   "miniprogramAppId": "",
    //   "miniprogramPage": "",
    //   "isXundaMiniprogram": 1,
    //   "xundaManufacturerId": '',
    //   "xundaManufacturerName": "",
    //   "miniprogramPicUrl": ""
    // }
  ],
};

const SelectionItemComponent = (props) => {
  const { value, multiple, data, onClick, currentWxworkList, usableCustomerList } = props;
  const checked = value.includes(data);
  const disableClick = !_.includes(usableCustomerList, data) && !_.includes(currentWxworkList, data) && !checked;
  const liOnClick = (args) => {
    if (disableClick) {
      return;
    }
    onClick(args);
  }
  const liClass = disableClick ? 'selection-info disabled' : 'selection-info';
  return (
    <li
      className={liClass}
      style={{ paddingLeft: '10px' }}
      onClick={liOnClick}
    >
      <Checkbox
          value='Checkbox'
          checked={checked}
          // onChange={onClick}
          // disabled={!_.includes(props.usableCustomerList, data) && !checked}
      >
        <ww-open-data type="userName" openid={data} />
      </Checkbox>
    </li>
  );
};

const ValueAreaComponent = (props) => {
  const { value, data, multiple, onOpen, open, placeholder } = props;

  return !value.length ? (
    <a onClick={onOpen} className="selection-single placeholder">
      <span className="selection-single-text">{placeholder}</span>
    </a>
  ) : (
    <a onClick={onOpen} className="selection-single">
      <span className="selection-single-text">
        {value.map((item, index) => (
          <span style={{ marginRight: '0px' }}>
            <ww-open-data type="userName" openid={item} />
            {index < value.length - 1 ? <span style={{ marginRight: '0px' }}>, </span> : null}
          </span>
        ))}
      </span>
    </a>
  );
};

const WelcomeEditDialog = (props) => {
  const { welcomeMsgId } = props.editData;
  const [allCustomerList, setAllCustomerList] = useState([]); // 所有客户
  const [usableCustomerList, setUsableCustomerList] = useState([]); // 可用的欢迎语客户

  const [uploadAttachList, setUploadAttachList] = useState([]); // 图片
  const [welcomeDetailInfo, setWelcomeDetailInfo] = useState({attachments: []});
  const [welcomeDetailInfoBackup, setWelcomeDetailInfoBackup] = useState({attachments: []});
  const [showWechatDialog, setWechatDialog] = useState(false);
  const [check, setCheck] = useState(false);
  const updateWelcomeInfo = (type, value) => {
    const newWelcomeDetailInfo = {...welcomeDetailInfo};
    newWelcomeDetailInfo[type] = value;
    setWelcomeDetailInfo(newWelcomeDetailInfo);
  }
  useEffect(() => {
    setCheck(false);
    setWelcomeDetailInfo({attachments: []});
    setWelcomeDetailInfoBackup({attachments: []});
    if (!props.show) {
      return;
    }
    // 获取所有客服
    RPCFactory.qwEmployee.getList()
    .done((data) => {
      const arr = data.entities.map((item) => item.wxWorkUserId);
      setAllCustomerList(arr);
      if (props.editData.wxWorkUserIdRange == 0) {// 客户范围 0 全部客服  1 具体的客服人员
        updateWelcomeInfo('wxWorkUserIdList', arr);
      }
    })
    .fail((ret, msg) => alert(msg));
  
    // 获取欢迎语客户
    RPCFactory.wechatWelcome.getWxworkWelcomeUserList()
    .done((data) => {
      setUsableCustomerList(data.wxWorkUserIdList);
    })
    .fail((ret, msg) => alert(msg));
    
    setWelcomeDetailInfo(welcomeDetailInfoInit);
    setWelcomeDetailInfoBackup(welcomeDetailInfoInit);
    setUploadAttachList(welcomeDetailInfoInit.attachments);

    // 获取欢迎语详情
    if (welcomeMsgId) {
      RPCFactory.wechatWelcome.getWelcomeMsgById(welcomeMsgId)
      .done((data) => {
        const detailInfo = 
        setWelcomeDetailInfo(_.pick(data, ['msgContent', 'welcomeMsgName', 'wxWorkUserIdList', 'welcomeMsgId', 'wxWorkUserIdRange']));
        setWelcomeDetailInfoBackup(_.pick(data, ['msgContent', 'welcomeMsgName', 'wxWorkUserIdList', 'welcomeMsgId', 'wxWorkUserIdRange']));
        const attachments = data.attachments.map((attachment) => {
          if (attachment.messageType === 'image') {
            return _.pick(attachment, ['messageType', 'cosKey', 'imgName']);
          }
          return _.omit(attachment, ['attachmentId', 'mediaUrl']);
        });
        setUploadAttachList(attachments);
      })
      .fail((ret, msg) => alert(msg));
    } else {
      setWelcomeDetailInfo(welcomeDetailInfoInit);
      setUploadAttachList(welcomeDetailInfoInit.attachments);
    }
  }, [props.show]);

  const handleSubmit = () => {
    setCheck(true);
    if (!welcomeDetailInfo.welcomeMsgName
      || !welcomeDetailInfo.msgContent
      || (welcomeDetailInfo.wxWorkUserIdRange === 1 && welcomeDetailInfo.wxWorkUserIdList.length === 0)
    ) {
      return;
    } else {
      const param = welcomeDetailInfo;
      param.attachments = uploadAttachList;
      // 增加或者修改欢迎语
      const promise = !welcomeDetailInfo.welcomeMsgId ? RPCFactory.wechatWelcome.addWelcomeMsg : RPCFactory.wechatWelcome.updateWelcomeMsg;
      promise(param)
        .done(() => {
          props.onSuccess();
        })
        .fail((code, msg) => {
          alert(msg);
        });
      props.onSuccess();
      props.onCancel();
    }
  };
  
  const handleUploadComplete = (err, xhr, resp = {}, fileInfo = {}, fileId) => {
    if (resp.code == 0 && resp.data) {
      setUploadAttachList([...uploadAttachList, {
        imgName: fileInfo.name,
        messageType: 'image',
        cosKey: resp.data.cosKey,
      }]);
    } else {
      alert('上传失败，失败原因： '+ resp.msg);
    }
  };

  const handleDeleteFile = (imgName) => {
    const newUploadFiles = uploadAttachList.filter(item => (item.imgName || item.miniprogramTitle) !== imgName);
    setUploadAttachList([...newUploadFiles]);
  };

  const addMiniprogramMsg = () => {
    setWechatDialog(true);
  };
  const handleWechatMsgSubmit = (item) => {
    // setWechatList([...wechatList, item]);
    setUploadAttachList([...uploadAttachList, item]);
  };
  const handleWechatMsgCancel = () => {
    setWechatDialog(false);
  };
  return (
    <>
      {true && <WechatEditDialog
        onSubmit={handleWechatMsgSubmit}
        show={showWechatDialog}
        onCancel={handleWechatMsgCancel}
      />}
      <Dialog
        show={props.show}
        onSubmit={handleSubmit}
        onCancel={props.onCancel}
        onClose={props.onCancel}
        type="normal"
        backdrop
        className="add-welcome-msg"
        title={welcomeDetailInfo.welcomeMsgId ? '编辑欢迎语' : '新建欢迎语'}
        style={{ width: '580px' }}
      >
        <div className="message-setting form-list-normal">
          <div className="lump lump-nohd">
            <div className="lump-bd">
              <ul className="infos">
                <li className="infolist">
                  <span className="info-tt">欢迎语名称</span>
                  <div className="info-des">
                    <FormGroup
                      error={check && welcomeDetailInfo.welcomeMsgName.length ===0 ? "欢迎语名称不能为空" : ''}
                    >
                      <Input
                        placeholder="请输入欢迎语名称"
                        maxLength={20}
                        value={welcomeDetailInfo.welcomeMsgName}
                        onChange={(e, value) => {
                          updateWelcomeInfo('welcomeMsgName', value);
                        } } />
                    </FormGroup>
                  </div>
                </li>
                <li className="infolist">
                  <span className="info-tt">客户范围</span>
                  <div className="info-des">
                    <FormGroup
                        error={check && welcomeDetailInfo.wxWorkUserIdList.length ===0 ? "请选择客户" : ''}
                      >
                      <Select
                        value={welcomeDetailInfo.wxWorkUserIdList}
                        onChange={(e, val) => updateWelcomeInfo('wxWorkUserIdList', val)}
                        placeholder='请选择'
                        data={allCustomerList}
                        SelectionItemComponent={(props) => SelectionItemComponent({ ...props, usableCustomerList, currentWxworkList: welcomeDetailInfoBackup.wxWorkUserIdList })}
                        ValueAreaComponent={ValueAreaComponent}
                        multiple
                        // checkAll
                      />
                    </FormGroup>
                  </div>
                </li>
                <li className="infolist">
                  <span className="info-tt info-tt-read">欢迎语内容</span>
                  <div className="info-des">
                    <FormGroup
                      feedback={welcomeDetailInfo.msgContent?.length + '/' + 1000}
                      error={check && welcomeDetailInfo.msgContent.length ===0 ? "欢迎语内容不能为空" : ''}
                    >
                      <Input
                        tagType="textarea"
                        placeholder="请输入文本内容"
                        value={welcomeDetailInfo.msgContent}
                        onChange={(e, val) => updateWelcomeInfo('msgContent', val)}
                        maxLength={1000} />
                    </FormGroup>
                  </div>
                </li>
                {!!uploadAttachList.length && <li className="infolist">
                  <span className="info-tt info-tt-read"></span>
                  <div className="info-des">
                    {uploadAttachList.map(item => {
                      let imgName = item?.imgName || item?.miniprogramTitle;
                      return (
                        <div className="uploaded-file-whole flex-apart">
                          <div className='uploaded-file-name'>
                            {!!item.imgName && <div className='icon-wechat-photo' />}
                            {!!item.miniprogramTitle && <div className='icon-wechat-miniprogram' />}
                            <span>{imgName}</span>
                          </div>
                          <Icon className='delete-outlined' name="delete-outlined" color='#2B2B2C' onClick={() => handleDeleteFile(imgName)} />
                        </div>
                      );
                    })}
                  </div>
                </li>}
                <li className="infolist">
                  <span className="info-tt info-tt-read"></span>
                  <div className="info-des flex-apart">
                    <Uploader
                      accept="image/bmp,image/png,image/jpeg,image/jpg,image/gif"
                      name="file"
                      style={{ marginTop: '10px' }}
                      headers={{ 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }}
                      url={`/api/v1/wx_work_msg/uploadfile?accountId=${window.pageProps.uid}&corpId=${window.pageProps.corpId }&csrfToken=${window.pageProps.token}&fileType=image`}
                      onComplete={handleUploadComplete}
                    >
                      <Button icon={<Icon type='x-plus' />} width={160} disabled={uploadAttachList.length >= 9}>
                        添加图片
                      </Button>
                    </Uploader>
                    <Button icon={<Icon type='x-plus' />} width={160} onClick={addMiniprogramMsg} disabled={uploadAttachList.length >= 9}>
                      添加小程序
                    </Button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default WelcomeEditDialog;
